import React, { useEffect, useRef, useState } from "react";
import { requestOtp, verifyOtp } from "../../services/publicSessionLinkService";
import "./sessionLanding.css";

const OTP_EXPIRY_SECS = 300;

const OtpScreen = ({ token, email, userName, onSuccess }) => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [secondsLeft, setSecondsLeft] = useState(OTP_EXPIRY_SECS);
  const [resendMsg, setResendMsg] = useState("");
  const timerRef = useRef(null);

  const startTimer = () => {
    setSecondsLeft(OTP_EXPIRY_SECS);
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setSecondsLeft((s) => {
        if (s <= 1) { clearInterval(timerRef.current); return 0; }
        return s - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    requestOtp(token, email);
    startTimer();
    return () => clearInterval(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleResend = async () => {
    setError("");
    setResendMsg("");
    const result = await requestOtp(token, email);
    if (result.data?.status === "OTP_SENT") {
      setResendMsg("OTP resent to your email.");
      startTimer();
    } else {
      setError(result.data?.message || result.message || "Failed to resend OTP.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otp.length !== 6) { setError("Please enter the 6-digit OTP."); return; }
    setLoading(true);
    const result = await verifyOtp(token, email, otp);
    setLoading(false);
    const data = result.data;
    if (data?.status === "SUCCESS") {
      if (data.jwtToken) localStorage.setItem("jwtToken", data.jwtToken);
      onSuccess({ userName: data.userName, bookingId: data.bookingId, userExists: true });
    } else {
      setError(data?.message || result.message || "Invalid OTP. Please try again.");
    }
  };

  const mm = String(Math.floor(secondsLeft / 60)).padStart(2, "0");
  const ss = String(secondsLeft % 60).padStart(2, "0");

  return (
    <div className="sl-state-page">
      <div className="sl-state-card">
        <span className="sl-state-icon">📧</span>
        <h2>Welcome back, {userName}!</h2>
        <p>We found your account. Enter the OTP sent to <strong>{email}</strong> to confirm your booking.</p>

        <form onSubmit={handleSubmit} className="sl-otp-form">
          <input
            className="sl-otp-input"
            type="text"
            inputMode="numeric"
            maxLength={6}
            value={otp}
            onChange={(e) => { setOtp(e.target.value.replace(/\D/g, "")); setError(""); }}
            placeholder="123456"
            autoFocus
          />
          {secondsLeft > 0
            ? <p className="sl-otp-timer">OTP expires in <strong>{mm}:{ss}</strong></p>
            : <p className="sl-otp-timer expired">OTP expired.</p>}
          {error && <p className="sl-form-error">{error}</p>}
          {resendMsg && <p className="sl-otp-resend-msg">{resendMsg}</p>}
          <button type="submit" className="sl-submit-btn" disabled={loading}>
            {loading ? "Verifying..." : "Verify & Book Session ✅"}
          </button>
        </form>

        <button className="sl-resend-btn" onClick={handleResend} disabled={secondsLeft > 0 && !error}>
          Resend OTP
        </button>
      </div>
    </div>
  );
};

export default OtpScreen;
